<template>
  <div>

    <p v-if="message !== null">
      {{message}}
    </p>

    <table
      v-if="clientPayments !== null && clientPayments.length > 0"
      class="table table-bordered text-nowrap"
    >
      <thead class="thead-dark">
        <tr class="text-center">
          <th colspan="5">Bill</th>
          <th colspan="2">Player</th>
          <th colspan="3">Service</th>
        </tr>
        <tr>
          <th scope="col">Id</th>
          <th scope="col">Time</th>
          <th scope="col">Extra info</th>
          <th scope="col">Status</th>
          <th scope="col">Result</th>
          <th scope="col">Role</th>
          <th scope="col">Gross</th>
          <th scope="col">Service</th>
          <th scope="col">Price</th>
          <th scope="col">Coins</th>
          <!-- <th scope="col">Products</th> -->
        </tr>
      </thead>
      <tr
        v-for="clientPayment in clientPayments"
        :key="clientPayment.id"
      >
        <td>
          {{clientPayment.id}}
        </td>
        <td>
          {{clientPayment.stamp | getMomentStr}}
        </td>
        <td>
            <span
              v-b-popover.click.top="clientPayment.order_id"
              class="tooltip-button"
            >order id</span>&nbsp;<span
              v-b-popover.click.top="clientPayment.payload"
              class="tooltip-button"
            >payload</span>
        </td>
        <td
          :class="getStatusClass(clientPayment)"
        >
          {{clientPayment.status | getEnumClientPaymentStatusNameFormatted}}
        </td>
        <td
          :class="getResultClass(clientPayment)"
        >
          <span
            v-b-popover.click.top="getClientPaymentFailDescription(clientPayment.result)"
            :class="resultLableClass(clientPayment.result)"
          >
            {{clientPayment.result | getEnumBillingPaymentResultName}}
          </span>
        </td>
        <td>
          {{clientPayment.qa_role | getQAUserRoleName}}
        </td>
        <td class="text-right">
          {{clientPayment.player_gross | getFormattedNumber}}
        </td>
        <td>
          {{clientPayment.sku | getShortBillingServiceId}}
        </td>
        <td class="text-right">
          {{clientPayment.price}}
        </td>
        <td class="text-right">
          {{clientPayment.gems | getFormattedDifference}}
        </td>
        <!-- <td>products</td> -->
      </tr>
    </table>

    <loading-indicator
      v-if="isLoading"
    />

  </div>
</template>

<script>
import { HTTP } from '../http-common';
import notifier from '../notifier';

import { isClientPaymentSuccessful               } from '../model/client-payment';
import { isClientPaymentFail                     } from '../model/client-payment';
import { getClientPaymentFailDescription         } from '../model/client-payment';
import { getEnumClientPaymentStatusNameFormatted } from '../model/client-payment';
import { getQAUserRoleName                       } from '../model/client-payment';

import { getEnumBillingPaymentResultName } from '../autogen/bundle';

import LoadingIndicator from './LoadingIndicator.vue';

export default {
  name: 'PlayerClientPayments',

  components: {
    LoadingIndicator,
  },

  props: {
    playerId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      isLoading: false,

      clientPayments: null,
    };
  },

  computed: {
    message() {
      if(this.clientPayments !== null && this.clientPayments.length === 0) {
        return 'This player has no client payments.';
      }
      return null;
    },
  },

  created() {
    this.loadClientPayments();
  },

  methods: {
    loadClientPayments() {
      notifier.deleteSenderNotifications(this);

      this.isLoading = true;

      const url = `/player/${this.playerId}/client_payments`;
      HTTP.get(url)
      .then(response => {
        this.isLoading = false;

        const data = response.data.data;
        if(data === null) {
          notifier.showError('Invalid server response. data === null.', {sender: this});
          return;
        }

        const clientPayments = data.clientPayments;
        clientPayments.sort((a, b) => b.stamp - a.stamp);

        this.clientPayments = clientPayments;
      })
      .catch(e => {
        this.isLoading = false;
        notifier.showError(e.response.data, {sender: this});
      });         
    },

    getStatusClass(clientPayment) {
      return getStateClass(clientPayment);
    },

    getResultClass(clientPayment) {
      return getStateClass(clientPayment);
    },

    resultLableClass(result) {
      const description = getClientPaymentFailDescription(result);
      const hasDescription = description !== null;
      return {
        'tooltip-button': hasDescription,
      };
    },

    getClientPaymentFailDescription,
  },

  filters: {
    getEnumClientPaymentStatusNameFormatted,
    getEnumBillingPaymentResultName,
    getQAUserRoleName,
  },
};

function getStateClass(clientPayment) {
  if(isClientPaymentSuccessful(clientPayment)) {
    return {
      'client-payment-success': true,
    };
  }

  if(isClientPaymentFail(clientPayment)) {
    return {
      'client-payment-fail': true,
    };
  }

  return {};
}
</script>

<style scoped>
.tooltip-button {
  text-decoration: underline;
  cursor: pointer;
}

.popover {
  max-width: 800px;
}

.client-payment-success {
  /*background-color: #c3e6cb;*/
  background-color: rgba(212, 237, 218);
}

.client-payment-fail {
  /*background-color: #e6c3c3;*/
  background-color: rgba(248, 215, 218)
}
</style>
